import { render, staticRenderFns } from "./DepartmentHeader.vue?vue&type=template&id=4ffe679f&scoped=true"
import script from "./DepartmentHeader.vue?vue&type=script&lang=js"
export * from "./DepartmentHeader.vue?vue&type=script&lang=js"
import style0 from "./DepartmentHeader.vue?vue&type=style&index=0&id=4ffe679f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffe679f",
  null
  
)

export default component.exports